<template>
    <div class="promoting_home">
        <div class="promoting1">
            <div class="p1_cont">
                <div class="swiper mySwiperSP1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide"><img src="../img/背景提升/banner1.jpg" alt=""></div>
                        <div class="swiper-slide"><img src="../img/背景提升/banner2.jpg" alt=""></div>
                        <div class="swiper-slide"><img src="../img/背景提升/banner3.jpg" alt=""></div>
                        <!-- <div class="swiper-slide"><img src="../img/背景提升/banner4.jpg" alt=""></div> -->

                    </div>

                    <!-- <div class="swiper-pagination"></div> -->
                </div>
            </div>
            <img src="../img/背景提升/leftShou.png" alt="" class="img_left">
            <img src="../img/背景提升/rightShou.png" alt="" class="img_right">
            <!-- <img src="" alt=""> -->
        </div>
        <div class="promoting2">
            <div class="p2_item">
                <div class="p2_item_title" @click="zhedie(0)">
                    <p>欧美顶级学府<br>喜欢怎样的学生？</p>
                    <div class="icon_box">
                        <div class="heng"></div>
                        <div class="shu" style="display: none;"></div>
                    </div>
                </div>
                <div class="p2_item_cont" style="height: 3.5rem;">
                    <p>对于中国学生来说，光有漂亮的分数已不能成为申请英美顶级院校的“制胜法宝”，背景提升项目也成为了申请过程中非常关键的“环节”。随着申请竞争越来越激烈，很多学生都开始在提升软实力方面投入努力，参与大量的课外活动进行背景提升。
                    </p>

                    <p>以哈佛大学的招生标准为例，参与社区活动、领导力、课外活动中的表现、个人特质等都是学校考量学生的点。这些都将成为申请中的闪光点之一。</p>

                    <p>课外活动的重要性早已不是秘密，而是公布于官网的“硬性要求”。</p>
                </div>
            </div>
            <div class="p2_item">
                <div class="p2_item_title" @click="zhedie(1)">
                    <p>什么是<br>背景提升？</p>
                    <div class="icon_box">
                        <div class="heng"></div>
                        <div class="shu"></div>
                    </div>
                </div>
                <div class="p2_item_cont">
                    <p>一段优秀的背景提升活动经历，会带来很多可以深挖的细节，从各个角度展现出学生的独特“人设”。这样的经历可以全面满足申请文书的填写需求，支撑起整份申请。
                        <br>
                        <br>RoSSo背景提升是目前市场上唯一一个专注于艺术专业留学生背景提升的品牌。从以作品集提升为主的夏校游学活动，到体现学生社会责任感的国际公益项目，再到以推荐信和实习证明为产出的职场辅导和实习，RoSSo背景提升全方位覆盖了艺术留学生的背景提升需求。
                    </p>
                </div>
            </div>
            <div class="p2_item">
                <div class="p2_item_title" @click="zhedie(2)">
                    <p>背景提升<br>的优势</p>
                    <div class="icon_box">
                        <div class="heng"></div>
                        <div class="shu"></div>
                    </div>
                </div>
                <div class="p2_item_cont p2_item_cont3">
                    <div class="p23_item">
                        <img src="../img/Group 138.png" alt="">
                        <p>促进创作灵感迸发 </p>
                        <p>打造高质量作品集</p>
                    </div>
                    <div class="p23_item">
                        <img src="../img/Group 139.png" alt="">
                        <p>获得推荐信/高金证书 </p>
                        <p>提升申请材料含金量</p>
                    </div>
                    <div class="p23_item">
                        <img src="../img/Group 137.png" alt="">
                        <p>提高综合软实力</p>
                        <p>助力名校申请</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="promoting3">
            <div class="section_box">
                <div class="section_title_cn">RoSSo背景提升项目</div>
                <div class="section_title_en">RoSSo PROMOTING PROJECTS</div>
            </div>

            <div class="promoting3_titleItem">
                <div class="promoting3_title" @click="zhedieP3(0)">
                    <p>学术提升</p>
                    <div class="jiantou"></div>
                </div>
                <div class="grid">
                    <div class="promoting3_a_box">
                        <div class="promoting3_a_item" @click="scrollP4item(0)">·海外夏校</div>
                        <div class="promoting3_a_item" @click="scrollP4item(1)">·海外游学</div>
                        <div class="promoting3_a_item" @click="scrollP4item(2)">·艺术研学</div>
                        <div class="promoting3_a_item" @click="scrollP4item(3)">·海外大师短期课</div>
                        <div class="promoting3_a_item" @click="scrollP4item(4)">·STUDIO CLASS</div>
                    </div>
                </div>
            </div>
            <div class="promoting3_titleItem">
                <div class="promoting3_title" @click="zhedieP3(1)">
                    <p>公益活动</p>
                    <div class="jiantou"></div>
                </div>
                <div class="grid">
                    <div class="promoting3_a_box">
                        <div class="promoting3_a_item" @click="scrollP4item(5)">·国际义工旅行</div>
                        <div class="promoting3_a_item" @click="scrollP4item(6)">·国际艺术公益</div>

                    </div>
                </div>
            </div>
            <div class="promoting3_titleItem">
                <div class="promoting3_title" @click="zhedieP3(2)">
                    <p>职场体验</p>
                    <div class="jiantou"></div>
                </div>
                <div class="grid">
                    <div class="promoting3_a_box">
                        <div class="promoting3_a_item" @click="scrollP4item(7)">·行业实训</div>
                        <div class="promoting3_a_item" @click="scrollP4item(8)">·职业导师</div>
                        <div class="promoting3_a_item" @click="scrollP4item(9)">·明星实习</div>
                        <div class="promoting3_a_item" @click="scrollP4item(10)">·海外实习</div>

                    </div>
                </div>
            </div>
        </div>
        <div class="promoting4">
            <div class="box" style="display: block;">
                <div class="promoting4_item">
                    <div class="p4Position"></div>

                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">海外夏校</p>
                            <p class="p2">OVERSEA SUMMER SCHOOL</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(0)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            带领学生前往海外顶尖艺术大学、英国G5高校、美国藤校等院校参加官方短期课程，获得学校官方证书。或带领学生参访顶级学府，与招生官面对面交流。在学习交流的同时，游玩当地知名景点，度过完美夏天！
                        </div>
                        <div class="p4_cont">
                            <img src="../img/背景提升/Rectangle 1006.png" alt="">

                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>定制课程：</h2>
                                <p>顶级名校专门定制的夏校课程，在校园里沉浸式体验名校课程；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>官方证书： </h2>
                                <p>合作院校官方结课证书+教授推荐信机会，高含金量背景提升；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>教授亲授：</h2>
                                <p>名校教授全程亲自指导项目产出，为作品集项目添砖加瓦；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>名校参访：</h2>
                                <p>探访更多周边知名学府，与招生官面对面，获取一手梦校资讯；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·海外实地</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·15-20人/班</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·根据具体项目</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·15-18岁</p>
                            </div>
                        </div>
                        <div class="p4_cont2_bottom">
                            <div class="p4_cont2_bottom_left">
                                <h1>海外夏校<br> 火热报名中！</h1>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                    <div>
                                        <p>即刻咨询</p>
                                        <img src="../img/背景提升/Group 719.png" alt="">
                                    </div>
                                </a>
                            </div>
                            <div class="p4_cont2_bottom_right">
                                <div class="swiper mySwiperP4">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外夏校-海报/1.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外夏校-海报/2.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外夏校-海报/3.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外夏校-海报/4.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外夏校-海报/5.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外夏校-海报/6.jpg" alt="" @click="imgCover($event)">
                                        </div>

                                    </div>
                                </div>
                                <img src="../img/背景提升/Group 656.png" alt="" class="changjt">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">海外游学</p>
                            <p class="p2">OVERSEA STUDY TOUR</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(1)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            联合海外学术机构、艺术工坊、艺术家工作室、名校毕业导师，为学生带来贴合实践的专业短期课程体验。通过学+游的综合体验，在提升学术能力，收获证书和产出的同时，拓宽学生的眼界！
                        </div>
                        <div class="p4_cont">
                            <div class="swiper mySwiperSP2">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外游学/1.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外游学/2.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外游学/3.jpg" alt="">
                                    </div>
                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>高金访学：</h2>
                                <p>海外知名学术机构和艺术工坊定制课程，提升设计思维;</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>艺术巡游： </h2>
                                <p>探访知名博物馆，打卡知名艺术街区，领略海外艺术魅力；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>人文风光：</h2>
                                <p>探索极致自然景观，体验当地人生活，培养全球化视野；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>背景提升：</h2>
                                <p>合作机构官方结课证书 + 作品集产出 + 推荐信机会。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·海外实地</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·15-20人/班</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·根据具体项目</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·15-21岁</p>
                            </div>
                        </div>
                        <div class="p4_cont2_bottom">
                            <div class="p4_cont2_bottom_left">
                                <h1>海外游学<br> 火热报名中！</h1>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                    <div>
                                        <p>即刻咨询</p>
                                        <img src="../img/背景提升/Group 719.png" alt="">
                                    </div>
                                </a>
                            </div>
                            <div class="p4_cont2_bottom_right">
                                <div class="swiper mySwiperP4">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外游学-海报/1.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外游学-海报/2.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外游学-海报/3.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                    </div>
                                </div>
                                <img src="../img/背景提升/Group 656.png" alt="" class="changjt">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 艺术研学 -->
                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">艺术研学</p>
                            <p class="p2">ART STUDY TRIP</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(2)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            艺术研学项目与优秀的国家非物质文化遗产传承人、研究机构、匠人工坊合作，通过深入学习非遗技艺，为学生提供深度了解、学习国家非物质文化遗产的机会。同时将非遗元素运用到现在设计中，丰富作品集特色与内涵！
                        </div>
                        <div class="p4_cont">
                            <div class="swiper mySwiperSP2">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/艺术研学/2.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/艺术研学/6.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/艺术研学/11.jpg" alt="">
                                    </div>
                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>田野调查：</h2>
                                <p>探访兼具自然和人文的目的地，发掘历史和背后的绚丽文化；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>文化传承： </h2>
                                <p>深入学习非遗技艺，并将学到的非遗元素运用到现代设计中</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>双师辅导：</h2>
                                <p>海外名校毕业导师+非遗导师全程指导，产出直接用于作品集；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>背景提升：</h2>
                                <p>获得官方结课证书、非遗导师推荐信机会，助力留学申请。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·国内实地</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·15-20人/班</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·根据具体项目</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·15-21岁</p>
                            </div>
                        </div>
                        <div class="p4_cont2_bottom">
                            <div class="p4_cont2_bottom_left">
                                <h1>艺术研学<br> 火热报名中！</h1>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                    <div>
                                        <p>即刻咨询</p>
                                        <img src="../img/背景提升/Group 719.png" alt="">
                                    </div>
                                </a>
                            </div>
                            <div class="p4_cont2_bottom_right">
                                <div class="swiper mySwiperP4">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/艺术研学-海报/1.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/艺术研学-海报/2.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/艺术研学-海报/3.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                    </div>
                                </div>
                                <img src="../img/背景提升/Group 656.png" alt="" class="changjt">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 海外大师短期课 -->
                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">海外大师短期课</p>
                            <p class="p2">MASTER CLASS</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(3)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            邀请海外顶尖院校的在职教授开设主题性短期课程，辅导学生了解中西方思维差异，提升设计思维和创新能力，短时间内进行高质量的学术和作品集产出。在海外大师的加持指导下，同学们诞生了非常多让人眼前一亮的作品！
                        </div>
                        <div class="p4_cont">
                            <img src="../img/背景提升/Rectangle 1007.png" alt="">
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>对话大师：</h2>
                                <p>周高强度海外名校教授与中文助教双师授课；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>小班教学： </h2>
                                <p>严控班级规模，保证每位同学都能得到教授的针对性指导；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目产出：</h2>
                                <p>可用于作品集的特定主题的项目产出；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>证书收获：</h2>
                                <p>不仅可获得课程证书，还有教授推荐信机会，丰富 PS/CV。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·远程线上</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·15人/班</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·根据具体项目</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·15-21岁</p>
                            </div>
                        </div>
                        <div class="p4_cont2_bottom">
                            <div class="p4_cont2_bottom_left">
                                <h1>海外大师短期课<br> 火热报名中！</h1>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                    <div>
                                        <p>即刻咨询</p>
                                        <img src="../img/背景提升/Group 719.png" alt="">
                                    </div>
                                </a>
                            </div>
                            <div class="p4_cont2_bottom_right">
                                <div class="swiper mySwiperP4">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/1.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/2.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/3.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/4.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/5.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/6.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/7.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/8.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                    </div>
                                </div>
                                <img src="../img/背景提升/Group 656.png" alt="" class="changjt">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- STUDIO CLASS -->
                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">STUDIO CLASS</p>
                            <p class="p2">STUDIO CLASS</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(4)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            深受同学们喜欢的金牌课程。小班课和小组协作的课堂形式，不仅能够让每位同学从导师身上、从同学身上获得灵感，启迪艺术思维，更让同学们提前适应欧美 TOP
                            艺术院校的教学模式，获得艺术作品集的创作收获。
                        </div>
                        <div class="p4_cont">
                            <div class="swiper mySwiperSP2">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/Studio Class/1.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/Studio Class/2.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/Studio Class/3.jpg" alt="">
                                    </div>
                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>主题丰富：</h2>
                                <p>艺术概念探索、前沿设计和技术、跨学科融合设计；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>有趣好玩： </h2>
                                <p>探索艺术边界，突破创作瓶颈，跨学科开拓眼界；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>师资强大：</h2>
                                <p>名校毕业学长导师 + 行业专家 + 艺术家 + 竞赛评委</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>产出丰富：</h2>
                                <p>有趣的作品集作品 + 导师推荐信机会 + 企业实习机会。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·远程线上</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·15人/班</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·根据具体项目</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·15-21岁</p>
                            </div>
                        </div>
                        <div class="p4_cont2_bottom">
                            <div class="p4_cont2_bottom_left">
                                <h1 style="white-space:nowrap">STUDIO CLASS<br> 火热报名中！</h1>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                    <div>
                                        <p>即刻咨询</p>
                                        <img src="../img/背景提升/Group 719.png" alt="">
                                    </div>
                                </a>
                            </div>
                            <div class="p4_cont2_bottom_right">
                                <div class="swiper mySwiperP4">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/Studio class-海报/1.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/Studio class-海报/2.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/Studio class-海报/3.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/Studio class-海报/4.jpg" alt="" @click="imgCover($event)">
                                        </div>

                                    </div>
                                </div>
                                <img src="../img/背景提升/Group 656.png" alt="" class="changjt">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box">
                <!-- 国际义工旅行 -->
                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">国际义工旅行</p>
                            <p class="p2">INTERNATIONAL VOLUNTEER</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(5)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            国际义工旅行与海外公益组织和机构合作，带领学生前往世界各地。在专业机构的指导下参与动植物保育、环境保护、国际支教等项目，同时开展公益的艺术创作，用作品向世界发出自己的声音。
                        </div>
                        <div class="p4_cont">
                            <div class="swiper mySwiperSP2">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国际义工旅行/1.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国际义工旅行/2.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国际义工旅行/3.jpg" alt="">
                                    </div>
                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>官方合作：</h2>
                                <p>与国际NGO及当地公益组织官方合作的定制项目；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>专业指导： </h2>
                                <p>专业机构老师全程指导，注重每位学生的过程体验；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>大地艺术：</h2>
                                <p>名校毕业艺术导师带领学生在当地完成大地艺术作品；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>高金证书：</h2>
                                <p>收获 NGO 及公益组织的多份公益证书，助力留学申请。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·海外实地</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·15-20人/班</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·不限</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·15-21岁</p>
                            </div>
                        </div>
                        <div class="p4_cont2_bottom">
                            <div class="p4_cont2_bottom_left">
                                <h1>国际义工旅行<br> 火热报名中！</h1>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                    <div>
                                        <p>即刻咨询</p>
                                        <img src="../img/背景提升/Group 719.png" alt="">
                                    </div>
                                </a>
                            </div>
                            <div class="p4_cont2_bottom_right">
                                <div class="swiper mySwiperP4">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/国际义工旅行-海报/1.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/国际义工旅行-海报/2.jpg" alt="" @click="imgCover($event)">
                                        </div>


                                    </div>
                                </div>
                                <img src="../img/背景提升/Group 656.png" alt="" class="changjt">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 国内艺术公益 -->
                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">国内艺术公益</p>
                            <p class="p2">DOMESTIC VOLUNTEER</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(6)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            国内艺术研学项目，将结合联合国教科文组织支持的国际画展项目，在参与公益活动的同时，将自己的所见所感转为为艺术创作。在名校毕业导师的指导下，完成绘画作品，获得画展证书、联合国教科文徽章及推荐信。
                        </div>
                        <div class="p4_cont">
                            <div class="swiper mySwiperSP2">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国内艺术公益/1.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国内艺术公益/2.jpg" alt="">
                                    </div>

                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>科学考察：</h2>
                                <p>深入热带雨林，了解雨林动植物和生态系统，进行科学实验；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>动物保护： </h2>
                                <p>近距离接触国家一级保护动物亚洲象，体验动物保护志愿者；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>背景提升：</h2>
                                <p>获得亚洲象保护协会公益证书 + 联合国国际画展荣誉证书；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>高性价比：</h2>
                                <p>用参加一次活动的时间和费用，完成多个不同类型的背景提升。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·国内实地</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·15-20人/班</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·不限</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·12-18 岁</p>
                            </div>
                        </div>
                        <div class="p4_cont2_bottom">
                            <div class="p4_cont2_bottom_left">
                                <h1>国内艺术公益<br> 火热报名中！</h1>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                    <div>
                                        <p>即刻咨询</p>
                                        <img src="../img/背景提升/Group 719.png" alt="">
                                    </div>
                                </a>
                            </div>
                            <div class="p4_cont2_bottom_right">
                                <div class="swiper mySwiperP4">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/国内艺术公益-海报/1.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                    </div>
                                </div>
                                <img src="../img/背景提升/Group 656.png" alt="" class="changjt">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 行业实训 -->
                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">行业实训</p>
                            <p class="p2">TRAINEE PROGRAM</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(7)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            行业实训为申请留学和毕业求职的同学提供高水平的行业活动体验。通过与行业大咖的对话、优秀企业的参访、以及真实商业项目的工作体验，为长期职业规划打下扎实的行业基础。
                        </div>
                        <div class="p4_cont">
                            <div class="swiper mySwiperSP2">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/行业实训/1.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/行业实训/2.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/行业实训/3.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/行业实训/4.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/行业实训/5.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/行业实训/6.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/行业实训/7.jpeg" alt="">
                                    </div>

                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>真实项目：</h2>
                                <p>参与真实的商业项目，体会理论知识与工作实操的区别；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>对话大咖： </h2>
                                <p>探访行业展会，对话行业大咖，深度了解行业内幕；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目证明：</h2>
                                <p>获得官方证明助力留学求职，更有机会获得大咖推荐信；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>积累人脉：</h2>
                                <p>提前积累优质行业人脉，为职业发展铺平道路。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·国内/海外实地</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·15-20人/班</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·根据具体项目</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·16-21 岁</p>
                            </div>
                        </div>
                        <div class="p4_cont2_bottom">
                            <div class="p4_cont2_bottom_left">
                                <h1>行业实训<br> 火热报名中！</h1>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                    <div>
                                        <p>即刻咨询</p>
                                        <img src="../img/背景提升/Group 719.png" alt="">
                                    </div>
                                </a>
                            </div>
                            <div class="p4_cont2_bottom_right">
                                <div class="swiper mySwiperP4">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/行业实训-海报/1.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/行业实训-海报/2.jpg" alt="" @click="imgCover($event)">
                                        </div>
                                    </div>
                                </div>
                                <img src="../img/背景提升/Group 656.png" alt="" class="changjt">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="box">
                <!-- 职场导师 -->
                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">职场导师</p>
                            <p class="p2">MENTORSHIP</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(8)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            职场导师邀请国内外时尚设计、互联网、世界 500 强企业的优秀企业导师，为学生提供接触行业一线工作内容、积累行业人脉的机会，并获得申请留学所必须的推荐信。
                        </div>
                        <div class="p4_cont">
                            <div class="swiper mySwiperSP2">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/职场导师/1.png" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/职场导师/2.png" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/职场导师/3.png" alt="">
                                    </div>


                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>职业规划：</h2>
                                <p>企业导师详细分析行业及岗位，找对人生方向；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>职场启蒙： </h2>
                                <p>近距离接触国家一级保护动物亚洲象，体验动物保护志愿者；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>高金推荐：</h2>
                                <p>名企导师推荐信，为留学申请和求职加分；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>服务跟踪：</h2>
                                <p>教务老师全程跟踪，定制专属提升方案。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·远程线上</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·1对1辅导</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·不限</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·16-21 岁</p>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- 明星实习 -->
                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">明星实习</p>
                            <p class="p2">DOMESTIC INTERNSHIP</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(9)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            明星实习为正在申请留学国外名校和正在为求职而寻找实习经验的年轻学生提供在行业一线工作实践的机会，并出具实习证明，让每一个学生都有机会成为一个合格的求职者，找到理想的人生目标。
                        </div>
                        <div class="p4_cont">
                            <div class="swiper mySwiperSP2">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/明星实习/1.png" alt="">
                                    </div>



                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>求职辅导：</h2>
                                <p>1对1简历 + 面试指导，提升申请质量；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>名企实习： </h2>
                                <p>明星企业 1-2 个月实地实习，收获工作经验；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>实习证明：</h2>
                                <p>企业官方实习证明，为留学申请和求职加分；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>服务跟踪：</h2>
                                <p>教务老师全程跟踪，定制专属提升方案。 PS/CV。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·国内实地</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·1对1咨询</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·不限</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·18-21 岁</p>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- 海外实习 -->
                <div class="promoting4_item">
                    <div class="p4Position"></div>
                    <div class="p4_title">
                        <div class="p4_title_left">
                            <p class="p1">海外实习</p>
                            <p class="p2">OVERSEA INTERNSHIP</p>
                        </div>

                        <img src="../img/背景提升/Group 654.png" alt="" class="p4_title_right" @click="showP4Cont2(10)">
                    </div>
                    <div class="p4_cont1">
                        <div class="p4_title2">
                            中国留学生如果想要在国外找一份名企实习是一件特别困难的事。海外实习致力于打造高端实习体验，为已经在海外留学的学生量身定制在地实习和求职计划，帮助学生顺利入职行业全球一线企业。
                        </div>
                        <div class="p4_cont">
                            <div class="swiper mySwiperSP2">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外实习/1.png" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外实习/2.png" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外实习/3.png" alt="">
                                    </div>



                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p4_cont2 animated">
                        <div class="p4_cont2_title">
                            <div class="p4_cont2_item">
                                <h2>高管直投：</h2>
                                <p>绕过海投，直接把简历内推给公司高管，提高获得面试的机会；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>门槛降低： </h2>
                                <p>同等岗位即使比公司的招聘要求稍低一点也可以获得 offer 机会；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>海量岗位：</h2>
                                <p>覆盖英、美、日等传统留学国家，专为艺术设计学生量身打造；</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>成功案例：</h2>
                                <p>累计帮助超过 1000 人获得世界 500 强等企业实习和就业机会。</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目地点：</h2>
                                <p>·国内实地</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>项目模式：</h2>
                                <p>·1对1咨询</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合专业：</h2>
                                <p>·不限</p>
                            </div>
                            <div class="p4_cont2_item">
                                <h2>适合年龄：</h2>
                                <p>·18-21 岁</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
const pow = window.innerWidth / 750
// console.log(pow,window.innerWidth);
import Swiper from 'swiper/bundle'
// import  Swiper from 'swiper/vue';
import 'swiper/css';
import "swiper/css/effect-cards";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "@/assets/css/promoting.css"
export default {
    data() {
        return {
            flag: [true, false, false],
            flag2: [false, false, false]
        }
    },
    created() {
        this.swiperSP1()
        // this.swiperSP2()
    },
    methods: {
        imgCover(e) {
            // var img = document.getElementsByTagName("img")
            var coverBlack = document.getElementById("coverBlack")
            console.log(coverBlack);
            coverBlack.style.display = "block"
            coverMainImg.src = e.target.src
            coverMainImg.style = "50%"
            // console.log(img);
            console.log(e.target.src);

        },
        scrollP4item(val) {
            var p4Position = document.getElementsByClassName("p4Position")

            p4Position[val].scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
        },
        showP4Cont2(val) {

            var p4_title_right = document.getElementsByClassName("p4_title_right")
            var p4_cont2 = document.getElementsByClassName("p4_cont2")
            var p4_cont1 = document.getElementsByClassName("p4_cont1")

            this.flag2[val] = !this.flag2[val]
            if (this.flag2[val]) {
                p4_title_right[val].src = require("../img/背景提升/Group 655.png")


                p4_cont2[val].style.display = "block"
                p4_cont1[val].style.display = "none"


                p4_cont2[val].classList.remove("bounceOutLeft")
                p4_cont2[val].classList.add("bounceInLeft")
            } else {

                p4_title_right[val].src = require("../img/背景提升/Group 654.png")
                p4_cont2[val].classList.add("bounceOutLeft")
                setTimeout(() => {
                    p4_cont1[val].style.display = "block"
                    p4_cont2[val].style.display = "none"
                }, 500)

            }
        },
        zhedieP3(val) {
            var grid = document.getElementsByClassName("grid")
            var jiantou = document.getElementsByClassName("jiantou")
            var box = document.getElementsByClassName("box")

            if (grid[val].style.gridTemplateRows == "0fr") {
                console.log("展开");
                grid[val].style.gridTemplateRows = "1fr"
                jiantou[val].style.transform = 'rotate(225deg)'
                box[val].style.display = "block"

            } else {


                console.log("合起");
                grid[val].style.gridTemplateRows = "0fr"
                jiantou[val].style.transform = 'rotate(45deg)'
                box[val].style.display = "none"
            }
        },
        zhedie(val) {
            this.flag[val] = !this.flag[val]
            var p2_item_cont = document.getElementsByClassName("p2_item_cont")
            var shu = document.getElementsByClassName("shu")
            if (this.flag[val]) {

                p2_item_cont[val].style.height = "3.5rem"
                shu[val].style.display = "none"
            } else {
                p2_item_cont[val].style.height = "0rem"
                shu[val].style.display = "block"
            }
        },
        swiperSP1() {
            var swiper = new Swiper(".mySwiperSP1", {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        swiperSP2() {
            var swiper = new Swiper(".mySwiperSP2", {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        swiperP4() {
            var swiper = new Swiper(".mySwiperP4", {
                slidesPerView: 2,
                spaceBetween: 24 * pow,
                observe: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }

    },
    mounted() {
        this.swiperSP1()
        this.swiperSP2()
        this.swiperP4()

    }
}

</script>